import { FaqAccordionItem } from "@/types/common";

export const buildFAQPage = (questions: FaqAccordionItem[]) => {
  const obj = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: buildMainEntity(questions),
  };
  return obj;
};

export const buildMainEntity = (items: FaqAccordionItem[]) => {
  return items.map((el) => {
    return {
      "@type": "Question",
      name: el.title,
      acceptedAnswer: {
        "@type": "Answer",
        text: el.answer || el.content,
      },
    };
  });
};
